import { DonationPage } from './DonationPage'
import { withDonationPage } from './withDonationPage'

const ConnectedDonationPage = withDonationPage(DonationPage)

export { ConnectedDonationPage as DonationPage }
